module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_0.6307d578.png";